<div class="add-new-users">
<breadcrumbs [path]="breadcrumbs"></breadcrumbs>
<div>
    <div>
        <h1>{{localize(langSection.AddUserPage, langText.AddNewUsers)}}</h1>
        <div class="add-new-users-subheader">
            <div>* {{localize(langSection.Term, langText.RequiredFieldNotice)}}</div>
            <div class="d-flex align-items-center">
                <div class="pe-2">{{localize(langSection.AddUserPage, langText.DownloadTemplate)}}: 
                    <a class="template-link" href="" (click)="downloadExcelTemplate(); $event.preventDefault();">Excel</a>
                </div>    
                <label for="file-upload" [class.disabled]="submitting || importing" class="import-users-button">
                    <span class="import-users-button-text">{{localize(langSection.AddUserPage, langText.ImportUsers)}}</span>
                    <input id="file-upload" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" (input)="importUsers($event)"/>
                </label>
            </div>
        </div>
    </div>
    <div>
        <add-user-form (addUserToQueue)="addUserToQueue($event)"></add-user-form>
    </div>
    @if (showErrorMessage) {
<div class="error-message">
        {{localize(langSection.AddUserPage, langText.ServerFailureNotification)}}
    </div>
}
    <div class="queue">
        <new-user-queue [locations]="locations" [totalUsers]="totalUsers" [locationUserListChange]="locationUserListChange"></new-user-queue>
    </div>
    <button (click)="saveUsers()" [disabled]="this.totalUsers < 1 || this.submitting || this.usersEditing || (queueErrorService.hasErrors$ | async)">{{localize(langSection.AddUserPage, langText.AddNewUsers)}}</button>
    <a class="cancel-link" href="#" (click)="cancelChanges($event)">{{localize(langSection.Term, langText.Cancel)}}</a>
</div>